import styles from "./RelatedFaculty.module.scss";
import RelatedEntities from "Explore/Components/RelatedEntities";
import { getRelatedAuthorsById } from "Explore/Services/Author";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useState } from "react";

const RelatedFaculty = () => {
  const { entity_id: faculty_id } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: true });

  useEffect(() => {
    setData({ data: [], isLoading: true });
    getRelatedAuthorsById({ id: faculty_id })
      .then((res) => {
        setData({ data: res.results, isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        setData({ data: [], isLoading: false });
      });
  }, []);

  return data.data.length > 0 ? (
    <div className={styles["related-entities"]}>
      <h2 className={styles["related-entities--title"]}>
        Similar Faculty Members
      </h2>
      <RelatedEntities
        entities={data}
        entityType="faculty"
        responsive={{
          superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 2,
            partialVisibilityGutter: 60,
          },
          desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2,
            partialVisibilityGutter: 60,
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            partialVisibilityGutter: 30,
          },
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default RelatedFaculty;
